import { createContext, useContext, useEffect, useState } from 'react'
import {  onAuthStateChanged } from "firebase/auth";
import { auth } from '../Firebase';
import axios from 'axios'

const AuthContext = createContext();

export function useAuth(){
    return useContext(AuthContext)
}

export function AuthProvider( {children} ){

    const [currentUser, setCurrentUser] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [venue, setVenue] = useState('all');
    const [isAdmin, setIsAdmin] = useState(false);
    const [role, setRole] = useState(null);

    const applyAuthToken = (user, token) => {
      user.accessToken = token
      axios.defaults.headers.common['AuthToken'] = token
      return user
    }

    const setupAxiosInterceptor = (user) => {
      axios.interceptors.response.use(
          response => response,
          async error => {
              const isExpiredToken =
                error.response?.status === 498 ||
                (error.response?.status === 403 && error.response?.data === 'Unauthorized')

              if (error.response && isExpiredToken && !error.config._retry) {
                  error.config._retry = true

                  try {
                      const tokenResult = await user.getIdTokenResult(true)
                      applyAuthToken(user, tokenResult.token)

                      const role = tokenResult?.claims?.role;
                      setRole(role || null);
                      setIsAdmin(role === 'admin');
                      setCurrentUser(user)

                      error.config.headers = error.config.headers || {}
                      error.config.headers['AuthToken'] = tokenResult.token

                      return axios(error.config)

                  } catch (refreshError) {
                      console.error('Failed to refresh token:', refreshError)
                  }
              }

              return Promise.reject(error)
          }
      )
  }

   
  useEffect(() => {
    let unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {

            // Retrieve the current valid token (force refresh)
            user.getIdToken(true).then((token) => {
                applyAuthToken(user, token)
                setupAxiosInterceptor(user)
                return user.getIdTokenResult(true);
            }).then((tokenResult) => {
                const role = tokenResult?.claims?.role;
                setRole(role || null);
                setIsAdmin(role === 'admin');
                setCurrentUser(user)
                setIsLoading(false)
            })
            .catch((error) => {
                setIsLoading(false)
                console.log("Error refreshing token", error)
            })
        } else {
            setCurrentUser(null)
            setIsAdmin(false)
            setRole(null)
            axios.defaults.headers.common['AuthToken'] = ""
            setIsLoading(false)
        }
    })

    return unsubscribe
}, [])


    const isDancerAdmin = role === 'dancerAdmin';

    const value = {
         currentUser, venue, setVenue, isAdmin, role, isDancerAdmin
    }
    
    return (
        <AuthContext.Provider value={value}>
            {!isLoading && children}
        </AuthContext.Provider>

    )
}

